import React, { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { MakeAxiosRequest } from '../../utils/handler';

function ChatBubble() {

    const [response, setResponse] = useState(null);
    const location = useLocation();
    const navigate = useNavigate();


    const fetchData = async () => {
        try {
            // Skip auto logout for polling requests to prevent automatic logout on temporary errors
            const res = await MakeAxiosRequest("post", "/getsupprotchatcount", {}, '', true);
            if (res && res.status == "1") {
                setResponse(res.data);

                // If there are unread chats and the user is currently
                // on any support chat page, trigger a refresh there.
                const supportPageRegexes = [
                    /^\/support$/,
                    /^\/servicerequest\/[^/]+\/support$/,
                ];

                const isOnSupportPage = supportPageRegexes.some((regex) =>
                    regex.test(location.pathname)
                );

                if ( isOnSupportPage) {
                    window.dispatchEvent(new CustomEvent("refreshSupportChat"));
                }
            } else if (res && (res.status == "-1" || res.status == "-3")) {
                // Don't log out on polling errors - these might be temporary
                // Only log errors, don't let polling trigger logout
                console.log("Chat count polling error:", res);
            }
        } catch (error) {
            // Silently handle errors in polling to prevent automatic logout
            // Only log if it's not a cancellation error
            if (error?.name !== 'CanceledError' && error?.response?.status !== 403) {
                console.log("Chat count polling error:", error);
            }
        }
    }

    useEffect(() => {
        // Initial fetch
        fetchData();
        // Poll every 3 seconds
        const intervalId = setInterval(fetchData, 5000);
        // Cleanup on unmount
        return () => clearInterval(intervalId);
    }, []);

    // Determine the support URL based on current route
    const navigateToSupport = () => {
        // Check if we're on a service details page (/servicerequest/:key)
        const match = location.pathname.match(/^\/servicerequest\/([^/]+)$/);
        if (match && match[1]) {
            // Extract the key from the pathname and navigate to service-specific support
            navigate(`/servicerequest/${match[1]}/support`);
        } else {
            // Navigate to general support page
            navigate("/support");
        }
    };

    // Hide chat bubble while already on any support chat page
    const isOnSupportPage = /^\/support$/.test(location.pathname)
        || /^\/servicerequest\/[^/]+\/support$/.test(location.pathname);

    if (isOnSupportPage) {
        return null;
    }

    return (
        <div className="chat-bubble-sec">
            <a className="chat-bubble" onClick={navigateToSupport}>
                <span className="support-txt">Chat</span>
                <i className="fa-solid fa-comments"></i>
                {response?.supportChatCount > 0 && (
                <span className="btn-ntfcn"></span>
                )}
            </a>
        </div>
    )
}

export default ChatBubble